import React from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Button,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Tooltip,
  Typography
} from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { withTheme } from "@material-ui/core/styles"
import { actionSaveUser } from "../../actions/UserActions"

import Util, {SUCCESS, ERROR} from "../../common/Util"
import Roles from "../../config/RolesConstants"
let _handleSubmitFail;

class AssignRolToUser extends React.PureComponent{
  constructor(props){
    super(props)
    this.state = {rolList:[], restoId:null, isDelivery:false}
    this.onSave=this.onSave.bind(this)
    this.renderFieldByRol=this.renderFieldByRol.bind(this)
    this.onChangeRestaurantAutocomplete=this.onChangeRestaurantAutocomplete.bind(this)
    this.onChangeRolAutocomplete=this.onChangeRolAutocomplete.bind(this)
    this.onDeleteRolChip=this.onDeleteRolChip.bind(this)
    this.onChangeDeliveryRestoAutocomplete=this.onChangeDeliveryRestoAutocomplete.bind(this)
    this.onDeleteDeliveryRestoChip=this.onDeleteDeliveryRestoChip.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)

  }

  componentWillReceiveProps(nextProps){
    try{      
      if(this.props.user!=nextProps.user){
        this.props.initialize({proRoles:[], proTicketsRedimir:[], deliveryRestaurant:[], ...nextProps.user})
        
        let isSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})>=0)
        let isDelivery = nextProps.user&&nextProps.user.proRoles&&(nextProps.user.proRoles.findIndex((r)=>{return r.id==Roles.DELIVERY})>=0)
        
        let restaurants  = [{id:"Beequick", evtTitle:"Beequick"}].concat(this.props.restaurantList.slice(0))
        if(isSuperAdmin){
          // console.log("USER", nextProps.user)
          let restoId = this.props.restaurantList.find((r)=>{return r.id == nextProps.user.proRestoId})
          this.setState({rolList:nextProps.rolList, restoId:restoId, isSuperAdmin:true, isDelivery:isDelivery, deliveryRes:restaurants})
        }else{
          let rolList = nextProps.rolList.filter((r)=>{return r.id!=Roles.SUPERADMIN && r.id!=Roles.ADMIN})
          // console.log("ROL LIST", rolList, nextProps.rolList)
          this.setState({rolList:rolList, isSuperAdmin:false, isDelivery:isDelivery, deliveryRes:restaurants})
        }
      }
    }catch(e){
      console.log("ERROR", e)
    }

  }
 
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSave(formValue){
    if(!this.state.isSuperAdmin){
      formValue.proRestoId = this.props.profile.proRestoId
    }
    this.props.actionSaveUser(
      formValue, 
      ()=>{
        Util.showNoty(SUCCESS, "Se asignaron los roles correctamente")
        this.props.onClose(SUCCESS)
      },
      (e)=>{
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudieron asignar los roles")
      }
    )
    
  }

  onChangeRestaurantAutocomplete(evt, newValue){
    let id = newValue&&newValue.id
    this.props.change("proRestoId", id)
    if(this.state.isSuperAdmin){
      this.setState({restoId:newValue})
    }
  }

  onChangeRolAutocomplete(evt, newValue){
    if(newValue){
      const exist = this.props.roles.some((r)=>{return r.id==newValue.id})
      // console.log("ON CHANGE AutoCOMPLETE", newValue, this.props.roles, exist)
      if(!exist){
        let r = this.props.roles.slice(0)
        if(newValue.id==Roles.DELIVERY){
            this.setState({isDelivery:true})
        }
        r.push(newValue)
        this.props.change("proRoles", r)
      }
    }
  }

  onDeleteRolChip(item){
    if(!this.state.isSuperAdmin&&(item.id==Roles.SUPERADMIN||item.id==Roles.ADMIN)){
      Util.showNoty(ERROR, "No puede eliminar este rol")
    }else{
      const nr = this.props.roles.filter((r)=>{return r.id!=item.id})
      this.props.change("proRoles", nr)      
      if(item.id == Roles.DELIVERY){
          this.setState({isDelivery:false})
        }
    }
  }

  onChangeDeliveryRestoAutocomplete(evt, newValue){
    if(newValue){
      const exist = this.props.deliveryRestaurant.some((r)=>{return r.id==newValue.id})
      if(!exist){
        let r = this.props.deliveryRestaurant.slice(0)
        r.push(newValue)
        this.props.change("deliveryRestaurant", r)
      }
    }
  }

  onDeleteDeliveryRestoChip(item){
    if(!this.state.isSuperAdmin&&(item.id==Roles.SUPERADMIN||item.id==Roles.ADMIN)){
      Util.showNoty(ERROR, "No puede eliminar este rol")
    }else{
      const nr = this.props.deliveryRestaurant.filter((r)=>{return r.id!=item.id})
      this.props.change("deliveryRestaurant", nr)      
    }
  }

  renderFieldByRol(){
    let components  = []
 
    if(this.state.isSuperAdmin){ 
      components.push (
        <Grid container item xs={12}>
          <InputLabel shrink>Seleccione el comercio asociado al usuario</InputLabel>
          <Autocomplete
            autoComplete
            options={this.props.restaurantList}
            getOptionLabel={option => option.evtTitle}
            onChange={this.onChangeRestaurantAutocomplete}
            value={this.state.restoId}
            renderInput={params => (
              <TextField {...params} fullWidth />
            )}
          />
        </Grid>
      )
    }
    if(this.state.isDelivery){
      components.push(
        <Grid container item xs={12}>
          <InputLabel shrink>Seleccione los comercios para los que reparte el delivery</InputLabel>
          <Autocomplete
                  autoComplete
                  options={this.state.deliveryRes}
                  getOptionLabel={option => option.evtTitle}
                  onChange={this.onChangeDeliveryRestoAutocomplete}
                  renderInput={params => (
                    <TextField {...params} fullWidth />
                  )}
                />
                <Box className="top10">
                  {this.props.deliveryRestaurant&&this.props.deliveryRestaurant.map((item,i)=>{
                    return <Chip key={`chip${i}`}
                                color="primary" 
                                label={item.evtTitle}
                                onDelete={()=>{this.onDeleteDeliveryRestoChip(item)}} />
                  })} 
                </Box>
        </Grid>
      )
    }
    if(components.length>0){
      return components
    }
    return (<Grid container item xs={12}/>)
  }

  render(){
    const {theme, open, rolList, handleSubmit, onClose} = this.props
    return (
      <Dialog open={open}>
        <DialogTitle>
          <Typography variant="h1" color="primary">Asignar rol a usuario</Typography>
          </DialogTitle>
        <DialogContent style={{minWidth:500}}>
          <form> 
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Field
                  component={TextField}
                  name="proEmail"
                  label="e-mail"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel shrink>Rol</InputLabel>
                <Autocomplete
                  autoComplete
                  options={this.state.rolList}
                  getOptionLabel={option => option.displayName}
                  onChange={this.onChangeRolAutocomplete}
                  renderInput={params => (
                    <TextField {...params} fullWidth />
                  )}
                />
                <Box className="top10">
                  {this.props.roles&&this.props.roles.map((item,i)=>{
                    return <Chip key={`chip${i}`}
                                color="primary" 
                                label={item.displayName}
                                onDelete={()=>{this.onDeleteRolChip(item)}} />
                  })} 
                </Box>
              </Grid>
              {this.renderFieldByRol()}
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancelar">
            <Button variant="contained" color="secondary" onClick={onClose}>Cancelar</Button>
          </Tooltip>
          <Tooltip title="Guardar">
            <Button variant="contained" color="primary" onClick={handleSubmit(this.onSave)}>Guardar</Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    rolList: store.rol.rolList,
    profile: store.auth.profile,
    restaurantList: store.evt.restaurantList,
    roles: store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRoles,
    deliveryRestaurant: store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.deliveryRestaurant
    // restoId: store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRestoId,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveUser
    },
    dispatch
  );
}

export default  reduxForm({
  form: "assignRolToUser",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AssignRolToUser)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/users/AssignRolToUser.js